import { Action, ActionCreator } from 'redux';

export enum ExpandedKeysActionTypes {
    SET_PROJECT_VERSION_EXPANDED_KEYS = 'SET_PROJECT_VERSION_EXPANDED_KEYS',
    SET_PROJECT_VARIANT_VERSION_EXPANDED_KEYS = 'SET_PROJECT_VARIANT_VERSION_EXPANDED_KEYS',
    SET_SOFTWARE_COMPONENTS_EXPANDED_KEYS = 'SET_SOFTWARE_COMPONENTS_EXPANDED_KEYS',
    SET_DATA_ELEMENT_DEFINITIONS_EXPANDED_KEYS = 'SET_DATA_ELEMENT_DEFINITIONS_EXPANDED_KEYS',
    SET_OPERATION_DEFINITIONS_EXPANDED_KEYS = 'SET_OPERATION_DEFINITIONS_EXPANDED_KEYS',
    SET_TRIGGER_DEFINITIONS_EXPANDED_KEYS = 'SET_TRIGGER_DEFINITIONS_EXPANDED_KEYS',
    SET_AUTOSAR_COMPONENT_EXPANDED_KEYS = 'SET_AUTOSAR_COMPONENT_EXPANDED_KEYS',
    SET_COMPOSITION_EXPANDED_KEYS = 'SET_COMPOSITION_EXPANDED_KEYS',
    SET_DATA_DICTIONARY_EXPANDED_KEYS = 'SET_DATA_DICTIONARY_EXPANDED_KEYS',
    SET_COLLAPSIBLES_EXPANDED_KEYS = 'SET_COLLAPSIBLES_EXPANDED_KEYS',
}

export interface ProjectVersionExpandedKeyChange extends Action {
    type: ExpandedKeysActionTypes.SET_PROJECT_VERSION_EXPANDED_KEYS;
    payload: {
        id: string;
        expandedKeys: string[];
    };
}

export interface ProjectVariantVersionExpandedKeyChange extends Action {
    type: ExpandedKeysActionTypes.SET_PROJECT_VARIANT_VERSION_EXPANDED_KEYS;
    payload: {
        id: string;
        expandedKeys: string[];
    };
}

export interface SoftwareComponentsExpandedKeyChange extends Action {
    type: ExpandedKeysActionTypes.SET_SOFTWARE_COMPONENTS_EXPANDED_KEYS;
    payload: {
        id: string;
        expandedKeys: string[];
    };
}

export interface DataElementDefinitionsExpandedKeyChange extends Action {
    type: ExpandedKeysActionTypes.SET_DATA_ELEMENT_DEFINITIONS_EXPANDED_KEYS;
    payload: {
        id: string;
        expandedKeys: string[];
    };
}

export interface OperationDefinitionsExpandedKeyChange extends Action {
    type: ExpandedKeysActionTypes.SET_OPERATION_DEFINITIONS_EXPANDED_KEYS;
    payload: {
        id: string;
        expandedKeys: string[];
    };
}

export interface TriggerDefinitionsExpandedKeyChange extends Action {
    type: ExpandedKeysActionTypes.SET_TRIGGER_DEFINITIONS_EXPANDED_KEYS;
    payload: {
        id: string;
        expandedKeys: string[];
    };
}

export interface AutosarComponentExpandedKeyChange extends Action {
    type: ExpandedKeysActionTypes.SET_AUTOSAR_COMPONENT_EXPANDED_KEYS;
    payload: {
        id: string;
        expandedKeys: string[];
    };
}

export interface CompositionExpandedKeyChange extends Action {
    type: ExpandedKeysActionTypes.SET_COMPOSITION_EXPANDED_KEYS;
    payload: {
        id: string;
        expandedKeys: string[];
    };
}

export interface DataDictionaryExpandedKeyChange extends Action {
    type: ExpandedKeysActionTypes.SET_DATA_DICTIONARY_EXPANDED_KEYS;
    payload: {
        id: string;
        expandedKeys: string[];
    };
}

export interface CollapsiblesExpandedKeyChange extends Action {
    type: ExpandedKeysActionTypes.SET_COLLAPSIBLES_EXPANDED_KEYS;
    payload: {
        key: string;
        isOpen: boolean;
    };
}

export type ExpandedKeysActions =
    | ProjectVersionExpandedKeyChange
    | ProjectVariantVersionExpandedKeyChange
    | SoftwareComponentsExpandedKeyChange
    | DataElementDefinitionsExpandedKeyChange
    | OperationDefinitionsExpandedKeyChange
    | TriggerDefinitionsExpandedKeyChange
    | AutosarComponentExpandedKeyChange
    | CompositionExpandedKeyChange
    | DataDictionaryExpandedKeyChange
    | CollapsiblesExpandedKeyChange;

export const dataDictionaryExpandedKeyChange: ActionCreator<DataDictionaryExpandedKeyChange> = (id: string, expandedKeys: string[]) => {
    return {
        type: ExpandedKeysActionTypes.SET_DATA_DICTIONARY_EXPANDED_KEYS,
        payload: {
            id,
            expandedKeys,
        },
    };
};

export const projectVersionExpandedKeyChange: ActionCreator<ProjectVersionExpandedKeyChange> = (id: string, expandedKeys: string[]) => {
    return {
        type: ExpandedKeysActionTypes.SET_PROJECT_VERSION_EXPANDED_KEYS,
        payload: {
            id,
            expandedKeys,
        },
    };
};

export const projectVariantVersionExpandedKeyChange: ActionCreator<ProjectVariantVersionExpandedKeyChange> = (id: string, expandedKeys: string[]) => {
    return {
        type: ExpandedKeysActionTypes.SET_PROJECT_VARIANT_VERSION_EXPANDED_KEYS,
        payload: {
            id,
            expandedKeys,
        },
    };
};

export const softwareComponentsExpandedKeyChange: ActionCreator<SoftwareComponentsExpandedKeyChange> = (id: string, expandedKeys: string[]) => {
    return {
        type: ExpandedKeysActionTypes.SET_SOFTWARE_COMPONENTS_EXPANDED_KEYS,
        payload: {
            id,
            expandedKeys,
        },
    };
};

export const dataElementDefinitionsExpandedKeyChange: ActionCreator<DataElementDefinitionsExpandedKeyChange> = (id: string, expandedKeys: string[]) => {
    return {
        type: ExpandedKeysActionTypes.SET_DATA_ELEMENT_DEFINITIONS_EXPANDED_KEYS,
        payload: {
            id,
            expandedKeys,
        },
    };
};

export const operationDefinitionsExpandedKeyChange: ActionCreator<OperationDefinitionsExpandedKeyChange> = (id: string, expandedKeys: string[]) => {
    return {
        type: ExpandedKeysActionTypes.SET_OPERATION_DEFINITIONS_EXPANDED_KEYS,
        payload: {
            id,
            expandedKeys,
        },
    };
};

export const triggerDefinitionsExpandedKeyChange: ActionCreator<TriggerDefinitionsExpandedKeyChange> = (id: string, expandedKeys: string[]) => {
    return {
        type: ExpandedKeysActionTypes.SET_TRIGGER_DEFINITIONS_EXPANDED_KEYS,
        payload: {
            id,
            expandedKeys,
        },
    };
};

export const autosarComponentExpandedKeyChange: ActionCreator<AutosarComponentExpandedKeyChange> = (id: string, expandedKeys: string[]) => {
    return {
        type: ExpandedKeysActionTypes.SET_AUTOSAR_COMPONENT_EXPANDED_KEYS,
        payload: {
            id,
            expandedKeys,
        },
    };
};

export const compositionExpandedKeyChange: ActionCreator<CompositionExpandedKeyChange> = (id: string, expandedKeys: string[]) => {
    return {
        type: ExpandedKeysActionTypes.SET_COMPOSITION_EXPANDED_KEYS,
        payload: {
            id,
            expandedKeys,
        },
    };
};

export const collapsiblesExpandedKeyChange: ActionCreator<CollapsiblesExpandedKeyChange> = (key: string, isOpen: boolean) => {
    return {
        type: ExpandedKeysActionTypes.SET_COLLAPSIBLES_EXPANDED_KEYS,
        payload: {
            key,
            isOpen,
        },
    };
};
